import articles from './articles';
import categories from './categories';
import tags from './tags';
import links from './links';
import resources from './resources';

export default {
    articles,
    categories,
    tags,
    links,
    resources
}